module.exports = __webpack_public_path__ + "static/media/photovideo.dfc134b4.svg";